import BackToTop from "./BackToTop";

export default BackToTop;
